'use client';

import { useEffect } from 'react';
import { useAuthStore } from '@/shared/stores/auth-store';

/**
 * Bootstraps the auth session once on client mount.
 *
 * The store's only other bootstrap path is inside the persist
 * `onRehydrateStorage` callback, which does NOT fire when this origin's
 * localStorage has no `tabootv-auth` entry — exactly the cross-subdomain case
 * (FRONT-168): a valid `.taboo.tv` cookie arrives but localStorage is empty on
 * the new subdomain, so `checkAuth()` never runs and the UI stays guest even
 * though `/api/me` would authenticate. This mount effect decouples the session
 * check from persist-hydration timing so a cookie-only session is always
 * discovered. `pendingAuthCheck` in the store dedups against the rehydrate path.
 */
export function AuthBootstrap() {
  const checkAuth = useAuthStore((s) => s.checkAuth);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return null;
}
